import React, { Component } from 'react'
import { push, goBack } from 'react-router-redux';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import shortid from 'shortid'
import { parseString } from 'dxf'

import './TemplateModal.css';

import Button from '../../components/Button/Button.js'
import PatternThumbnail from '../../components/PatternThumbnail/PatternThumbnail.js'
import CustomField from '../../components/CustomField/CustomField.js'
import Tabs from '../../components/Tabs/Tabs.js'
import LoginForm from '../../components/LoginForm/LoginForm.js'

import { setTemplateModalOpen } from '../../actions/actions.export.js';

import canI from '../../canI.js';

class TemplateModal extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {     
      search: ''
    }

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal(){
    const { dispatch } = this.props;

    dispatch(setTemplateModalOpen(false))      
  }

  componentDidMount(){
    // document.addEventListener("keydown", this.handleCloseModal, false);
  }

  componentWillUnmount(){
    // document.removeEventListener("keydown", this.handleCloseModal, false);
  }

  render(){
    const { dispatch, globalReducer, patternManager, user, team } = this.props; 
    
    if(!globalReducer.templateModalOpen) return "";

    function calculatorThumbnail(p, i, j, name){
      let preHeat = patternManager.pristineCache[p].projects.indexOf('Preheat') > -1;
      let canAccessTemplates = canI(user, team, 'calculator_access', team.current);

      let locked = false;
      let lockedMessage = "";

      if(!preHeat){
        if(canAccessTemplates){
          locked = false;
        } else {
          locked = true;
          lockedMessage = "Upgrade to Pro or create a team to use this template."
        }
      }

      return <div key={j + '-' + i} className="col-lg-4 col-md-6 col-sm-1 theme-light">
        <small>
          {
            j === 0 ? <span className="text-primary">{name} <i className="fal fa-angle-right"/></span> : <span>&nbsp;</span>
          }
        </small>

        <PatternThumbnail 
          locked={locked}
          lockedMessage={lockedMessage} 
          template={true}
          cacheID={p} 
          onClick={(e)=> { 
            dispatch(setTemplateModalOpen(false)) 
          }}
          />
      </div>
    }

    var hasSearchResults = false;
    for(var i in patternManager.officialCalculators){
      var p = patternManager.officialCalculators[i];
      if(patternManager.pristineCache[p].name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1){
        hasSearchResults = true;
        break;
      }
    }


    patternManager.officialCalculators.sort((a,b)=>{
      let pa = patternManager.pristineCache[a];
      let pb = patternManager.pristineCache[b];

      if(pa.projects.indexOf('Preheat') > -1 && pb.projects.indexOf('Preheat') === -1) return -1;
      if(pa.projects.indexOf('Preheat') === -1 && pb.projects.indexOf('Preheat') > -1) return 1;
      return 0;
    })


    return <div className="template-modal modal theme-light">
      <div className="modal-bg" onClick={this.handleCloseModal}>
      </div>
      <div className="modal-inner">
        <div className="flex-split">
          <span>
            <strong>Choose a template to get started</strong>
          </span>
          <span>
            <Button size="squared-normal" color="borderless" display={<i className="fal fa-times fa-lg fa-fw"/>} onClick={this.handleCloseModalCancel}/> 
          </span>
        </div>
        <hr/>
        <div className="row row-push-down">
          <div className="col-md-12">
            <CustomField
              value={this.state.search}
              name="search"
              type='text'
              placeholder='search templates'
              inline={true}
              onChange={(e)=> { this.setState({search: e}) }}
              description="We've sorted templates by category, but search here to find something specific."
              form={false}
              />
          </div>
        </div>
        {
          patternManager.tryingToGetOfficialCalculators && 
          <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <p className="lead">
                <i className="fad fa-spinner-third fa-spin"/> Loading...
              </p>
            </div>
          </div>
        }
        {
          (this.state.search && !hasSearchResults) && <div className="row justify-content-center">
            <div className="col-md-6 text-center">
              <h3><i className="fal fa-frown fa-fw fa-lg"/></h3>
              <p className="lead">
                Can't find any templates by that name!<br/>Suggest one and we'll make it happen.
              </p>
            </div>
          </div>
        }

        {
          <div className="row">
            {
              patternManager.officialCalculators.map((p, i) => {
                if(!this.state.search) return calculatorThumbnail(p, i);
                if(this.state.search && patternManager.pristineCache[p].name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1){
                  return calculatorThumbnail(p, i);
                }
                
              })
            }
          </div>
        }
      </div>
    </div>


    
  }
}

const mapStateToProps = (state) => {
  const { globalReducer, patternManager, user, team } = state;

  return {
    globalReducer, patternManager, user, team
  }
}

export default connect(mapStateToProps)(TemplateModal);



// WEBPACK FOOTER //
// ./src/components/TemplateModal/TemplateModal.js